// state
const state = {
  login: {
    isLogin: false,
    auth: {},
  },
  shipmentDetail: {},
  shipmentBatchDetail: {},
};

export default state;
